import type { DeepPartial } from '@nuxt/ui'
import type theme from '#build/ui/tabs'

const tabs: DeepPartial<typeof theme> = {
  slots: {
    root: 'items-start gap-0',
    list: 'p-0 ',
    indicator: 'duration-300',
    label: 'font-semibold font-body text-lg underline video-listing-block__tab-heading',
    trigger: [
      'w-full relative inline-flex shrink-0 items-start gap-2 font-semibold leading-6 rounded-xl',
      'transitions-normal data-[state=inactive]:text-primary hover:data-[state=inactive]:not-disabled:text-primary data-[state=active]:bg-(--color-med-light-aqua)',
      'focus:outline-hidden desktop:leading-7 disabled:cursor-not-allowed disabled:opacity-75',
    ] as any,
    leadingIcon: 'size-5',
  },
  variants: {
    variant: {
      link: {
        list: 'border-med-light-aqua',
        indicator: 'rounded-full',
      },
    },
    orientation: {
      horizontal: {
        root: 'xl:gap-5 gap-4',
        list: 'no-scrollbar overflow-auto border-b',
        trigger: 'justify-center px-7 pb-4 pt-0',
      },
      vertical: {
        root: 'gap-[13px] items-stretch',
        list: 'w-full max-w-[40%] bg-transparent block',
        indicator: 'right-0 top-0',
        trigger: 'px-7 py-4',
      },
    },
  },
  compoundVariants: [{
    orientation: 'horizontal',
    variant: 'link',
    class: {
      list: 'border-b -mb-px',
      indicator: '-bottom-px h-[3px]',
    },
  }, {
    orientation: 'vertical',
    variant: 'link',
    class: {
      list: 'border-s-0 border-e -me-1',
      indicator: '-end-px w-1 start-auto',
    },
  }, {
    color: 'neutral',
    variant: 'link',
    class: {
      indicator: 'bg-primary',
      trigger: 'data-[state=active]:text-primary focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary',
    },
  }],
  defaultVariants: {
    variant: 'link',
    color: 'neutral',
  },
}

export default tabs
